var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        'app-index': true,
        'app-index--sidebar': _vm.hasSidebar
    }},[(_vm.hasSidebar)?_c('keep-alive',[_c('router-view',{staticClass:"app-index__sidebar",attrs:{"name":"sidebar"}})],1):_vm._e(),_c('div',{staticClass:"app-index__main"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }